import React, { useEffect, useState } from "react";
import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { Button } from "baseui/button";
import { useNavigate, useParams } from "react-router-dom";
import request from "../../utils/http";
import { Radio, RadioGroup } from "baseui/radio";
import FileUploadImplementation from "../../components/form/FileUploadImplementation";

const AssetFileCreate = () => {
	const urlParams = useParams() as any;
	const navigate = useNavigate();

	const [name, setName] = useState("");
	const [notes, setNotes] = useState("");
	const [type, setType] = useState("");
	const [departmentType, setDepartmentType] = useState("");
	const [file, setFile] = useState(null as any);

	const createFile = async () => {
		await request("POST", "/api/admin/asset-file/create", {
			name,
			notes,
			type,
			departmentType,
			cloudFileId: file?.cloudFileId,
		});

		navigate({
			pathname: `/files`,
		});
	};

	return (
		<>
			<h1>Upload File</h1>
			<div>
				<FormControl label={"Name"}>
					<Input
						value={name}
						onChange={(e) => {
							setName(e.currentTarget.value);
						}}
					/>
				</FormControl>
				<FormControl label={"Notes"}>
					<Input
						value={notes}
						onChange={(e) => {
							setNotes(e.currentTarget.value);
						}}
					/>
				</FormControl>
				<FormControl label="Type">
					<>
						<RadioGroup
							value={type}
							onChange={(e) => setType(e.currentTarget.value)}
						>
							<Radio value="Signature">Signature</Radio>
							<Radio value="PositionDescription">Job Description</Radio>
							<Radio value="Onboarding">Onboarding</Radio>
						</RadioGroup>
					</>
				</FormControl>
				<FormControl label="Department Type">
					<>
						<RadioGroup
							value={departmentType}
							onChange={(e) => setDepartmentType(e.currentTarget.value)}
						>
							<Radio value="PPCS">PPCS</Radio>
							<Radio value="PFMS">PFMS</Radio>
							<Radio value="PIL">PIL</Radio>
						</RadioGroup>
					</>
				</FormControl>				<FormControl label="File Upload">
					<>
						<FileUploadImplementation
							value={file}
							onChange={setFile}
							targetUrl={`/api/admin/utility/upload`}
						/>
					</>
				</FormControl>
				<div>
					<Button onClick={createFile}>Create</Button>
				</div>
			</div>
		</>
	);
};
export default AssetFileCreate;
